import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class HourService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  sendMessage() {
    this.cmd = '3A41';

    const frTime = moment(Date.now())
      .tz('Europe/Paris')
      .format('YYYY-MM-DDTHH:mm:ss');
    const date = new Date(frTime + 'Z');
    var ts = Math.floor(date.getTime() / 1000);
    console.log('DATE TS : ', ts);
    this.cmd = this.cmd + this.littleToBigEndian(ts.toString(16));

    console.log(' CMD DATE : ', this.cmd);

    this.ble
      .writeWithoutResponse(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.txUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Result Write : ', data);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public receiveResponse(data: any) {
    console.log('response hour');
    console.log(this.buf2hex(data).toLowerCase());
    if (this.buf2hex(data).toLowerCase() == '3a01') {
      return true;
    }
    return false;
  }

  public convertDateForIos(date) {
    var arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return date;
  }
}
